import { arcadeChapterOfLevel } from "./chapters.ts";
import { ARCADE_CONTENT_VERSION, ARCADE_PACK_LOADERS } from "./packs.generated.ts";
import { arcadePackSchema, type ArcadeLevel, type ArcadePack } from "./schema.ts";

const packCache = new Map<number, Promise<ArcadePack>>();

/** Loads (once) and validates one Fun Arcade chapter pack; nothing of the house downloads before. */
export function loadArcadeChapter(chapter: number): Promise<ArcadePack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = ARCADE_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no arcade pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = arcadePackSchema.parse(raw);
      if (pack.contentVersion !== ARCADE_CONTENT_VERSION) throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadArcadeLevel(levelId: number): Promise<ArcadeLevel> {
  const pack = await loadArcadeChapter(arcadeChapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`arcade level ${levelId} missing from pack`);
  return level;
}
